export const environment = {
  api_url: 'https://api.lumapos.lk',
  app_url: 'https://invoice-admin.lumapos.lk',
  landing_app_url: 'https://lumapos.lk',
  google_map_api_key: 'AIzaSyDV_8AbwTltwaL6vVu-l0yuh7ENRSVI3Is',
  google_client_id:'397783503319-0u20eachgvh5mm52b3v5bpedu6vmjngk.apps.googleusercontent.com',
  facebook_app_id: ''
};
